module.exports = "pegasus/assets/theme3/facebook-icon.png";